<div [formGroup]="formGroup" *ngIf="!isLoading">
  <!-- Section label -->
  <div class="icm-section-header" *ngIf="getCategoryDisplayName()">
    <span class="icm-label" [ngClass]="{ required: fields.isRequired }">
      {{ getCategoryDisplayName() }}
    </span>
  </div>

  <!-- ── Tile Grid ─────────────────────────────────────── -->
  <div class="icm-grid">
    <ng-container *ngFor="let option of fieldsData; trackBy: trackById">
      <div
        *ngIf="shouldShowOption(option)"
        class="icm-card"
        [ngClass]="{
          'icm-card--connected':
            option.fieldDependencies != null &&
            (option.status?.toLowerCase() === 'connected' ||
              option.status?.toLowerCase() === 'reconnected'),
          'icm-card--reconnect':
            option.fieldDependencies != null &&
            option.status?.toLowerCase() === 'reconnect',
          'icm-card--failed':
            option.fieldDependencies != null &&
            (option.status?.toLowerCase() === 'failed' ||
              option.status?.toLowerCase() === 'connection_failed' ||
              option.status?.toLowerCase() === 'connection failed'),
          'icm-card--disconnected':
            option.status?.toLowerCase() === 'disconnected',
          'icm-card--soon': option.fieldDependencies == null
        }"
      >
        <!-- ── Visual header with logo ── -->
        <div class="icm-card-top">
          <div class="icm-logo-frame">
            <img
              [src]="getIconUrl(option)"
              [alt]="option.platformName"
              class="icm-logo"
              [class.icm-logo--fallback]="getIconUrl(option) === defaultIconUrl"
              (error)="handleImageError(option, $event)"
            />
          </div>

          <!-- Connected / Status badge with animated dot -->
          <div
            class="icm-connected-badge"
            [ngClass]="{
              'icm-badge--connected':
                option.status?.toLowerCase() === 'connected' ||
                option.status?.toLowerCase() === 'reconnected',
              'icm-badge--reconnect':
                option.status?.toLowerCase() === 'reconnect',
              'icm-badge--disconnected':
                option.status?.toLowerCase() === 'disconnected',
              'icm-badge--failed':
                option.status?.toLowerCase() === 'failed' ||
                option.status?.toLowerCase() === 'connection_failed' ||
                option.status?.toLowerCase() === 'connection failed',
            }"
            *ngIf="isSelected(option)"
          >
            <span
              class="icm-connected-dot"
              [ngClass]="{
                'icm-dot--connected':
                  option.status?.toLowerCase() === 'connected' ||
                  option.status?.toLowerCase() === 'reconnected',
                'icm-dot--reconnect':
                  option.status?.toLowerCase() === 'reconnect',
                'icm-dot--disconnected':
                  option.status?.toLowerCase() === 'disconnected',
                'icm-dot--failed':
                  option.status?.toLowerCase() === 'failed' ||
                  option.status?.toLowerCase() === 'connection_failed' ||
                  option.status?.toLowerCase() === 'connection failed',
              }"
            ></span>
            {{
              option.status?.toLowerCase() === 'connected'
                ? 'Connected'
                : option.status?.toLowerCase() === 'connection_failed' ||
                  option.status?.toLowerCase() === 'connection failed'
                ? 'Failed'
                : (option.status | titlecase)
            }}
          </div>

          <!-- Coming soon ribbon -->
          <!-- <span
            class="icm-ribbon"
            *ngIf="!isSelected(option) && option.fieldDependencies == null"
          >
            Soon
          </span> -->
        </div>

        <!-- ── Name + description ── -->
        <div class="icm-body">
          <span class="icm-name">{{ option.platformName }}</span>
          <span class="icm-desc">{{ option.description }}</span>
        </div>

        <!-- ── Footer: action button ── -->
        <div class="icm-footer">
          <button
            *ngIf="
              isSelected(option) &&
              (option.status?.toLowerCase() === 'reconnect' ||
                option.status?.toLowerCase() === 'failed' ||
                option.status?.toLowerCase() === 'connection_failed' ||
                option.status?.toLowerCase() === 'connection failed')
            "
            class="icm-btn icm-btn--reconnect"
            (click)="toggleSelection(option, 'connect')"
          >
            <div
              class="icm-loader"
              *ngIf="loadingCards.has(option._id?.toString())"
            ></div>
            <svg
              *ngIf="!loadingCards.has(option._id?.toString())"
              width="11"
              height="11"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M13.65 2.35A7.958 7.958 0 0 0 8 0a8 8 0 1 0 8 8h-2a6 6 0 1 1-6-6c1.66 0 3.14.69 4.22 1.78L10 6h6V0l-2.35 2.35z"
                fill="currentColor"
              />
            </svg>
            {{
              loadingCards.has(option._id?.toString())
                ? "Reconnecting..."
                : "Reconnect"
            }}
          </button>

          <button
            *ngIf="!isSelected(option)"
            class="icm-btn icm-btn--connect"
            (click)="toggleSelection(option, 'connect')"
          >
            <div
              class="icm-loader"
              *ngIf="loadingCards.has(option._id?.toString())"
            ></div>
            <svg
              *ngIf="!loadingCards.has(option._id?.toString())"
              width="11"
              height="11"
              viewBox="0 0 12 12"
              fill="none"
            >
              <path
                d="M6 1v10M1 6h10"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
            Connect
          </button>

          <button
            *ngIf="
              isSelected(option) && option.status?.toLowerCase() === 'connected'
            "
            class="icm-btn icm-btn--disconnect"
            (click)="toggleSelection(option, 'disconnect')"
          >
            <svg width="10" height="10" viewBox="0 0 12 12" fill="none">
              <path
                d="M1 6h10"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
            Disconnect
          </button>
        </div>
      </div>
    </ng-container>
  </div>

  <!-- Integration Not in Current Category Message -->
  <div
    *ngIf="fieldsData && fieldsData.length > 0 && !hasVisibleOptions()"
    class="flex flex-col items-center justify-center py-16 px-4 text-center"
  >
    <i class="ki-filled ki-information-2 text-2xl text-warning mb-3"></i>
    <span class="text-sm font-semibold text-gray-800 mb-1">
      This integration is not in the current category
    </span>
    <span class="text-xs text-gray-500 max-w-[320px]">
      Please select another category from the left menu or clear your
      search/selection.
    </span>
  </div>

  <!-- Validation -->
  <div *ngIf="showValidationError" class="icm-error">
    Please select an option.
  </div>
</div>

<!-- ── Skeleton ─────────────────────────────────────────── -->
<div *ngIf="isLoading" class="icm-grid">
  <div *ngFor="let i of [1, 2, 3, 4, 5, 6]" class="icm-card icm-card--skeleton">
    <div class="icm-card-top icm-card-top--sk">
      <div class="icm-sk icm-sk-logo"></div>
    </div>
    <div class="icm-body">
      <div class="icm-sk icm-sk-title"></div>
      <div class="icm-sk icm-sk-desc"></div>
      <div class="icm-sk icm-sk-desc icm-sk-desc--short"></div>
    </div>
    <div class="icm-footer">
      <div class="icm-sk icm-sk-btn"></div>
    </div>
  </div>
</div>

<!-- ── Connection Modal (unchanged) ─────────────────────── -->
<div
  class="modal"
  data-modal="true"
  data-modal-disable-scroll="false"
  [id]="'connection_modal_' + fields.fieldName"
>
  <div
    class="modal-content mx-auto my-5 w-full max-w-[600px] sm:rounded-lg shadow-lg bg-white dark:bg-coal-500"
  >
    <div class="modal-header flex justify-between items-center p-4 border-b">
      <span class="font-semibold text-base ms-2 card-title">{{
        modalTitle
      }}</span>
    </div>
    <div class="modal-body gap-5 p-4">
      <app-modal-renderer
        #modalRendererRef
        *ngIf="activeModalContext"
        [nodeId]="currentNodeId"
        (formSaved)="onModalFormSaved($event)"
        (closeModal)="closeModal('connection_modal_' + fields.fieldName)"
        [workflowData]="workflowData"
        [recordID]="recordID"
        [workflowId]="workflowId"
        (clickedOnPrevious)="clickedOnPrevious()"
        (header)="setModalTitle($event)"
        (checkPollingServiceForError)="checkPollingServiceForError($event)"
        [activeModalContext]="activeModalContext"
      ></app-modal-renderer>
    </div>
  </div>
</div>

<!-- ── Coming Soon Modal ────────────────────────────────── -->
<div
  class="modal"
  data-modal="true"
  data-modal-disable-scroll="false"
  [id]="'coming_soon_modal_' + fields.fieldName"
>
  <div class="coming-soon-modal-content bg-white dark:bg-coal-500">
    <!-- Rocket Icon Area -->
    <div class="rocket-container">
      <div class="rocket-circle">
        <!-- Golden/Yellow Rocket SVG -->
        <svg class="rocket-icon" viewBox="0 0 24 24" fill="none">
          <!-- Rocket Body -->
          <path
            d="M4.5 16.5c-1.5 1.5-2.5 3.5-2.5 5.5 2-.001 4-1 5.5-2.5l11.084-11.084c.828-.828.828-2.17 0-3-.828-.828-2.17-.828-3 0L4.5 16.5z"
            fill="#EAB308"
            stroke="#EAB308"
            stroke-width="1.5"
            stroke-linejoin="round"
          />
          <!-- Wings / Fins -->
          <path d="M12 9l-4-4c-.75.75-1.5 1.75-2 3l3 3 3-2z" fill="#CA8A04" />
          <path d="M15 12l-4-4c.75-.75 1.75-1.5 3-2l3 3-2 3z" fill="#CA8A04" />
          <!-- Flame -->
          <path
            d="M2.5 21.5c.5-1.5 1.5-2 2-2.5s1-.5 1-1"
            stroke="#F97316"
            stroke-width="2"
            stroke-linecap="round"
          />
          <!-- Window/Dot -->
          <circle cx="14.5" cy="9.5" r="1.5" fill="#1e2b48" />
        </svg>
      </div>
      <!-- Tiny Sparkles / Stars -->
      <span class="sparkle sparkle-1">✦</span>
      <span class="sparkle sparkle-2">✦</span>
      <span class="sparkle sparkle-3">✦</span>
      <span class="sparkle sparkle-4">✦</span>
      <span class="sparkle sparkle-5">✦</span>
    </div>

    <!-- Title & Content -->
    <h3 class="coming-soon-title text-gray-800">Coming Soon!</h3>
    <p class="coming-soon-text">
      We're working hard to bring this integration to you.<br />
      Stay tuned – Exciting things are on the way!
    </p>

    <!-- Got It Button -->
    <button
      type="button"
      class="coming-soon-btn btn btn-sm btn-brand-primary"
      (click)="closeModal('coming_soon_modal_' + fields.fieldName)"
    >
      Got It
    </button>
  </div>
</div>
